var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loading'),_c('Elite',{attrs:{"role":"university"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }